import * as actionTypes from "../actions/actionTypes";

const initialState = {
  filterByCategory: 0,
  filterByFloor: 0,
  filterByName: "",
  filterFloorFromHome: false
};

const filterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.FILTER_BY_CATEGORY:
      return { ...state, filterByCategory: payload };

    case actionTypes.FILTER_BY_FLOOR:
      return { ...state, filterByFloor: payload };

    case actionTypes.FILTER_BY_NAME:
      return { ...state, filterByName: payload };

    case actionTypes.CLEAR_FILTER_FLOOR:
      return { ...state, filterByFloor: initialState.filterByFloor };

    case  actionTypes.FILTER_BY_FLOOR_FROM_HOME:
      return { ...state, filterFloorFromHome: payload };

    case actionTypes.CLEAR_ALL_FILTER:
      return { ...initialState };

    default:
      return state;
  }
};

export default filterReducer;
